import { InternalAxiosRequestConfig } from 'axios'
import { store } from '../../../../state/configure_store'
import humps from 'humps'

export const injectBaseParams = (config: InternalAxiosRequestConfig) => {
  const fullParams = humps.decamelizeKeys({
    ...config.params,
    token: store.getState().user.user?.token,
    userId: store.getState().user.user?.id,
    environment: 'web',
    appVersion: '2.0.0',
    relationId: store.getState().relations.currentRelation?.id,
    relationNumber: store.getState().relations.currentRelation?.relationNumber
  })

  config.params = fullParams

  return config
}
